import { FC } from 'react';
import { LayoutConst, ModalControllerContainer } from 'core';
import { useTranslation } from 'react-i18next';
import { PrivacyPolicyEng } from "../../components/legals/PrivacyPolicy/PrivacyPolicyEng";
import { PrivacyPolicyRu } from "../../components/legals/PrivacyPolicy/PrivacyPolicyRu";
import styled from "styled-components";
import { SectionContent } from "../../components/legals/styles";
import { AppTester } from "../../../supporting";
import { PrivacyPolicyOnlines } from "../../components/legals/onlinesDocuments/PrivacyPolicyOnlines";
import { PrivacyPolicyOnlinesKz } from "../../components/legals/onlinesDocuments/PrivacyPolicyOnlinesKz";

const LegalsWrapper = styled.div`
  margin: 0 auto;
  max-width: 560px;
  padding: 64px 0;
  ${SectionContent} {
    margin-left: 0;
  }
  overflow-y: scroll;
  -ms-overflow-style: none;
  scrollbar-width: 0;
  &::-webkit-scrollbar {
    display: none;
  }
  @media (max-width: ${LayoutConst.screen.m}px) {
    padding: 200px 10px;
  }
`

const LegalsModal: FC = () => {
  const { i18n: { language } } = useTranslation();
  const isOnlines = AppTester.isOnlines();

  return <ModalControllerContainer>
    <LegalsWrapper>
      {isOnlines && (language === 'kz' ? <PrivacyPolicyOnlinesKz /> : <PrivacyPolicyOnlines />)}
      {!isOnlines && (language === 'en' ? <PrivacyPolicyEng/> : <PrivacyPolicyRu/>)}
    </LegalsWrapper>
  </ModalControllerContainer>

};

export default LegalsModal;import { FC } from 'react';
import { LayoutConst, ModalControllerContainer } from 'core';
import { useTranslation } from 'react-i18next';
import { PrivacyPolicyEng } from "../../components/legals/PrivacyPolicy/PrivacyPolicyEng";
import { PrivacyPolicyRu } from "../../components/legals/PrivacyPolicy/PrivacyPolicyRu";
import styled from "styled-components";
import { SectionContent } from "../../components/legals/styles";
import { AppTester } from "../../../supporting";
import { PrivacyPolicyOnlines } from "../../components/legals/onlinesDocuments/PrivacyPolicyOnlines";
import { PrivacyPolicyOnlinesKz } from "../../components/legals/onlinesDocuments/PrivacyPolicyOnlinesKz";

const LegalsWrapper = styled.div`
  margin: 0 auto;
  max-width: 560px;
  padding: 64px 0;
  ${SectionContent} {
    margin-left: 0;
  }
  overflow-y: scroll;
  -ms-overflow-style: none;
  scrollbar-width: 0;
  &::-webkit-scrollbar {
    display: none;
  }
  @media (max-width: ${LayoutConst.screen.m}px) {
    padding: 200px 10px;
  }
`

const LegalsModal: FC = () => {
  const { i18n: { language } } = useTranslation();
  const isOnlines = AppTester.isOnlines();

  return <ModalControllerContainer>
    <LegalsWrapper>
      {isOnlines && (language === 'kz' ? <PrivacyPolicyOnlinesKz /> : <PrivacyPolicyOnlines />)}
      {!isOnlines && (language === 'en' ? <PrivacyPolicyEng/> : <PrivacyPolicyRu/>)}
    </LegalsWrapper>
  </ModalControllerContainer>

};

export default LegalsModal;